<div class="eau-validation-error" *ngIf="isInvalid()">
    {{ getErrorMsg() | translate: getInterpolateParams() }}
</div>
